import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private loading = new BehaviorSubject<boolean>(false);
  private counter = 0;
  loading$ = this.loading.asObservable();

  show() {
    // if (this.counter === 0){
      this.counter++;
      this.updateLoading();
    // }
  }

  hide() {
      if (this.counter > 0) {
      this.counter--;
    }
    this.updateLoading();
  }
    reset() {
    this.counter = 0;
    this.updateLoading();
  }
  private updateLoading() {
    this.loading.next(this.counter > 0);
  }
}
